import { useEffect } from 'react';
import { useTheme } from '@/theme';
import { useUITranslatedText } from '@/components/TranslatedText';

export default function DocumentTitle() {
    const theme = useTheme();
    const defaultTitle = theme.metadata?.title ?? 'Those Beyond';
    const translation_pageTitle = useUITranslatedText('title', defaultTitle);

    useEffect(() => {
        document.title = translation_pageTitle;
    }, [translation_pageTitle]);

    return null;
}
